// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1116":"9d7bd950","1802":"905dd73c","2407":"9d7bd950","3076":"9d7bd950","9980":"9d7bd950"}[chunkId] + ".chunk.css";
};